<div class="success-wrapper">
  <section class="success-section">
    <div class="success-container">
      <div class="success-content">
        <img
          [src]="'/assets/illustrations/' + illustration"
          class="success-illustration"
          alt="Success illustration"
        />
        <h1 *ngIf="title" class="success-title">{{ title }}</h1>
        <p *ngIf="message" class="success-subtitle">{{ message }}</p>
      </div>
      <div class="success-actions">
        <button type="button" ps-primary-button (click)="handleAction()">
          <span class="button-text primary-button-text">{{ buttonText }}</span>
        </button>
      </div>
    </div>
  </section>
</div>
